import React from "react";
import { format } from "date-fns";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function Chart({selectedChart, sensorData, timestamps}) {
    const options = {
    plugins: {
        legend: {
            display: false
            // position: 'top' as const,
        },
        // title: {
        //     display: true,
        //     text: 'Chart.js Line Chart',
        // },
    },
    responsive: true,
    interaction: {
        mode: "index",
        intersect: false,
    },
    stacked: false,
    scales: {
        y: {
        type: "linear",
        display: true,
        position: "left",
        },
        x: {
            ticks: {
                autoSkip: true,
                maxRotation: 90,
                minRotation: 45
            }
        }
    },
    };

    const labels = timestamps.map(timestamp => format(new Date(timestamp), "d/M/y HH:mm").toString());
    var label = null;

    if(selectedChart === "water_level") {
        label = selectedChart.charAt(0).toUpperCase() + selectedChart.slice(1);
        label = label.replace("_", " ");
    }
    else label = selectedChart.charAt(0).toUpperCase() + selectedChart.slice(1);

    const data = {
        labels,
        datasets: [
            {
                label: label,
                data: sensorData,
                borderColor: "rgb(25, 135, 84)",
                backgroundColor: "rgba(18, 119, 72, 0.5)",
                radius: 0,
                yAxisID: "y",
            },
        ],
    };

    return (<Line options={options} data={data} />)
}

export default Chart;